import { GoldWreath } from './GoldWreath';

export default GoldWreath;
